/**
 * Payment mode options for ERA automation exclusion list.
 * Keys MUST match backend ERA_PAYMENT_MODE constant values.
 */
export const ERA_PAYMENT_MODES = [
    { id: "CHK", name: "Check (CHK)" },
    { id: "ACH", name: "ACH / EFT" },
    { id: "FWT", name: "Federal Wire Transfer (FWT)" },
    { id: "BOP", name: "Financial Institution Option (BOP)" },
    { id: "NON", name: "Non-Payment Data (NON)" },
];

/** Matches clearing_house ERAAutopostCustomPaymentRule.RuleType */
export const RULE_TYPE_DENIAL_ROUTING = 1;
export const RULE_TYPE_ADJUSTMENT = 2;

/** Matches RemarkMatchCondition — labels are for UI only */
export const REMARK_MATCH_HAS_ANY = 1;
export const REMARK_MATCH_HAS_NONE = 2;
export const REMARK_MATCH_NOT_APPLICABLE = 3;

export const REMARK_MATCH_OPTIONS = [
    { value: REMARK_MATCH_HAS_ANY, labelKey: "hasAny" },
    { value: REMARK_MATCH_HAS_NONE, labelKey: "hasNone" },
    { value: REMARK_MATCH_NOT_APPLICABLE, labelKey: "notApplicable" },
];

/** LedgerAction choices for denial rules (matches backend enum) */
export const LEDGER_ACTION_KEEP = 1;
export const LEDGER_ACTION_SHIFT = 2;
export const LEDGER_ACTION_SHIFT_TO_PATIENT = 3;

export const LEDGER_ACTION_OPTIONS = [
    { value: LEDGER_ACTION_KEEP, labelKey: "keepBalance" },
    { value: LEDGER_ACTION_SHIFT, labelKey: "shiftResponsibility" },
    { value: LEDGER_ACTION_SHIFT_TO_PATIENT, labelKey: "shiftToPatient" },
];

export const CLAIM_STATUS_TIER_PRIMARY = 1;
export const CLAIM_STATUS_TIER_SECONDARY = 2;
export const CLAIM_STATUS_TIER_TERTIARY = 3;
export const CLAIM_STATUS_TIER_PATIENT = 4;

export const TAB_ADJUSTMENTS = "adjustments";
export const TAB_DENIALS = "denials";
export const TAB_SYSTEM_DEFAULT_RULES = "systemDefaultRules";


